document.querySelectorAll("[data-video-wrapper]").forEach(wrapper => {
    const video = wrapper.querySelector("[data-video]");
    const toggleBtn = wrapper.querySelector("[data-video-toggle]");
    const overlay = wrapper.querySelector(".overlay");
    if (!video || !toggleBtn || !overlay) return;
  
    const playIcon = toggleBtn.querySelector("[data-play-icon]");
    const pauseIcon = toggleBtn.querySelector("[data-pause-icon]");
  
    function playVideo() {
      const paused = video.paused;
      overlay.style.display = paused ? "block" : "none";
      playIcon.classList.toggle("hidden", !paused);
      pauseIcon.classList.toggle("hidden", paused);

      wrapper.classList.toggle("is-paused", paused);
    }
  
    toggleBtn.addEventListener("click", e => {
      e.stopPropagation();
      video.paused ? video.play() : video.pause();
    });
  
    wrapper.addEventListener("click", () => {
      if (video.paused) video.play();
    });
  
    video.addEventListener("play", playVideo);
    video.addEventListener("pause", playVideo);
  
    playVideo();
  });